import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
    selector: 'app-base-widget',
    imports: [CommonModule],
    templateUrl: './base-widget.component.html',
    styleUrls: ['./base-widget.component.scss']
})
export class BaseWidgetComponent {
  readonly error = input<string>('');
  readonly card = input<boolean>(true);
  readonly cardClass = input<string>(''); 
}
